import cache from 'memory-cache';

export function clearPageCache(start_key: string) {
	const keys = cache.keys();
	keys.forEach((key) => {
		if (key.startsWith(start_key)) {
			cache.del(key);
		}
	});
}

export function putPageCache(start_key: string, payload: any, data: any) {
	if (payload === '') {
		cache.put(`${start_key}`, data, 1000 * 60 * 60);
	} else if (payload._id || payload.id) {
		cache.put(`${start_key}_${payload?._id ? payload._id : payload.id}`, data, 1000 * 60 * 60);
	} else {
		cache.put(`${start_key}_${payload.perPage}_${payload.pageNo}`, data, 1000 * 60 * 60);
	}
}

export function getPageCache(start_key: string, payload: any) {
	if (payload === '') {
		return cache.get(`${start_key}`);
	} else if (payload._id || payload.id) {
		return cache.get(`${start_key}_${payload?._id ? payload._id : payload.id}`);
	} else if (!payload.perPage || !payload.pageNo) {
		return cache.get(`${start_key}`);
	} else if (cache.get(`${start_key}_${payload.perPage}_${payload.pageNo}`)) {
		return cache.get(`${start_key}_${payload.perPage}_${payload.pageNo}`);
	}
}
